import { render } from "./ProjectEditComponent.vue?vue&type=template&id=4b9f1292"
import script from "./ProjectEditComponent.vue?vue&type=script&lang=js"
export * from "./ProjectEditComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__